import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { Row, Col, CardBody, Input, Button, Table, FormGroup, InputGroup, InputGroupAddon } from 'reactstrap';
import queryString from 'query-string';
import moment from "moment";
import { toast } from 'react-toastify';
import Select from 'react-select';
import { isEmpty } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import Flatpickr from 'react-flatpickr';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import { baseUrl } from '../../constants/environment';
import { checkRole } from '../../helpers/Roles';
import IconSearch from '../../assets/images/icon-search.png';
import IconCalendarBlack from '../../assets/images/icon/ic_calendar-black.svg';
import IconEdit from '../../assets/images/icon-edit.png';
import BatchDetail from '../batch/BatchDetail';
import CalcUtils from '../../helpers/CalcUltils';

const configPage = {
    titlePage: 'Danh sách lô',
    pathPage: '/batch',
    column: 10,
}

interface Props {
    history: any,
    location: any,
    user: any,
}
const initialParams = {
    page: 1,
    limit: 25,
    filter: {}
}

export const ProductStatusDate:any = [
    {
        value: 'het_han',
        label: "Đã hết hạn",
    },
    {
        value: 'con_han_duoi_3',
        label: "Còn < 3 tháng",
    },
    {
        value: 'con_han_duoi_6',
        label: "Còn < 6 tháng",
    },{
        value: 'con_han_tren_6',
        label: "Còn > 6 tháng",
    },
]

const List: React.FC<Props> = (props: Props) => {
    const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState<any>({});
    const [category, setCategory] = useState<any>([]);
    const searchPrams = queryString.parse(props.location.search)

    const setPage = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            page: value
        }));
    }

    const setLimit = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            limit: value
        }));
    }

    const setFilter = (value: {}) => {
        setParams((prevState: any) => ({
            ...prevState,
            filter: value
        }));
    }

    useEffect(() => {
        document.title = configPage.titlePage
        getFilterParams()
        loadInit()
    }, []);

    useEffect(() => {
        loadData()
        setFilterParams({
            page:page,
            limit: limit,
            ...filter,
        });
    }, [filter, page, limit]);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const getFilterParams = () => {
        const newFilter: any = {}
        if (!isEmpty(searchPrams)) {
            Object.keys(searchPrams).map(function (key) {
                switch (key) {
                    case 'page':
                        setPage(Number(searchPrams[key]))
                        break;
                    case 'limit':
                        setLimit(Number(searchPrams[key]))
                        break;
                    default:
                        newFilter[key] = searchPrams[key]
                        break;
                }
            });
            setFilter(newFilter)
        }
    }

    const setFilterParams = (params: any) => {
        var filterParams = ''
        Object.keys(params).map(function (item, i) {
            if (i === 0) {
                if (params[item]) filterParams = filterParams + '?' + item + '=' + params[item]
            } else {
                if (params[item]) filterParams = filterParams + '&' + item + '=' + params[item]

            }
        });
        props.history.push({
            search: filterParams
        })
    }

    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 100,
        }
        const [
            responseCategory,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/category`, params),
        ]);
        if (responseCategory.response?.data !== undefined) {
            let ListArr:any = [{
                value: "",
                label: "-Danh mục-",
            }];
            responseCategory.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setCategory(ListArr)
        }
    }

    const loadData = async () => {
        setLoading(true);
        const formData = {
            page: page,
            limit: limit,
            role: 'user',
            ...filter,
        }
        if(formData?.name === "") {
            delete formData?.name
        }
        if(formData?.product_type === "") {
            delete formData?.product_type
        }
        if(formData?.category_id === "") {
            delete formData?.category_id
        }
        if(formData?.role_id === "") {
            delete formData?.role_id
        }
        if(formData?.production_date_from && formData?.production_date_to) {
            formData.production_date_from = moment(formData?.production_date_from).startOf('day').valueOf()
            formData.production_date_to = moment(formData?.production_date_to).endOf('day').valueOf()
        }
        if(formData?.expiration_date_from && formData?.expiration_date_to) {
            formData.expiration_date_from = moment(formData?.expiration_date_from).startOf('day').valueOf()
            formData.expiration_date_to = moment(formData?.expiration_date_to).endOf('day').valueOf()
        }
        const url = `${baseUrl}/product-batch`;
        let response: any = await APIClient.GET(url, formData);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error)
        } else if (response.response?.data !== undefined) {
            setData(response?.response?.data)
            setTotalElements(response?.response?.total)
        }
    }

    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: configPage.titlePage, active: true },
                ]}
                title={configPage.titlePage}
            />
            <PageBody>
                <DataFilter
                    filter={filter}
                    category={category}
                    configPage={configPage}
                    setFilter={(filter: any) => setFilter(filter)}
                />
                <DataTableList
                    user={props?.user}
                    data={data} loading={loading}
                    page={page} limit={limit}
                    configPage={configPage}
                    history={props.history}
                    handleActionModal={(data: any) => handleActionModal(data)}
                />
                <Pagination
                    link={configPage.pathPage + '/list'}
                    setPage={(page: number) => setPage(page)}
                    page={page}
                    limit={limit}
                    setLimit={(limit: number) => setLimit(limit)}
                    totalElements={totalElements}
                />
            </PageBody>
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                {action?.type === 'edit' || action?.type === 'view' ? 
                    <BatchDetail closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()} batch_id={action?.data?.id} />:
                    <RenderActionModal {...props} closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()}/>
                }
            </ModalPopup>
        </React.Fragment>
    );
};

export const calTotalStockQuantity = (stock_quantity:any)=>{
    return stock_quantity?.reduce((prev:any, item:any)=>{
        prev += Number(item?.quantity)
        return prev
    },0)
}

const DataTableList = (props: any) => {
    const { data, filter, loading, limit, page, configPage, handleActionModal} = props
    const start = limit * (page - 1)

    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th style={{ minWidth: 60}}>Mã lô</th>
                    <th style={{ minWidth: 120 }}>Ngày sản xuất</th>
                    <th style={{ minWidth: 120 }}>Ngày hết hạn</th>
                    <th style={{ minWidth: 120 }}>Tên sản phẩm</th>
                    <th style={{ minWidth: 120 }}>Phiên bản sản phẩm</th>
                    <th style={{ minWidth: 120 }}>Tồn kho </th>
                    <th style={{ minWidth: 120 }} >Trạng thái</th>
                    <th style={{ minWidth: 120 }} >Hành động</th>
                </tr>
            </thead>
        )
    }

    const RenderBobyData = () => {
        const router = useHistory()
        if (loading) {
            return <RowLoading column={configPage.column} row={data.length || limit} />
        }
        if (data.length === 0) {
            return <RowEmpty column={configPage.column} title="Chưa có lô nào!" />;
        }

        const gotoDetail = (item:any) => {
            props?.handleActionModal({type: 'view', data: item})
        }
         
        return (
            <tbody>
                {data && data?.length > 0 && data?.map((item: any, index: number) => {
                    const totalStockQuantity = calTotalStockQuantity(item?.stock_quantity)
                    const calExpiry = CalcUtils.getExpiryStatus(item?.expiration_date)
                    return(
                        <tr key={`${item?.id}-${index}`}>
                            <td style={{ minWidth: 120}} onClick={() => gotoDetail(item)}>{item?.name}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.production_date ? moment(item?.production_date).format('DD/MM/YYYY') : '---'}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.expiration_date ? moment(item?.expiration_date).format('DD/MM/YYYY') : '---'}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.product_id?.name}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.variant_id?.name || "---" }</td>
                            <td onClick={() => gotoDetail(item)}>{PriceUtils.format(totalStockQuantity, '') || 0}</td>
                            <td onClick={() => gotoDetail(item)}>
                                <span className={calExpiry?.calssName}><b>{calExpiry?.title}</b></span>
                            </td>
                            <td>
                                <div className="table-action">
                                    <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'edit', data: item})}>
                                        <img style={{border: 'none'}} src={IconEdit} width={20} height={20} alt=""/>
                                    </div>
                                    <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'delete', data: item})}><i className='uil-trash-alt'></i></div>
                                </div>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        )
    }

    return (
        <div>
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
        </div>
    );
};

const DataFilter = (props: any) => {
    const { setFilter, filter, category} = props
    const [name, setName] = useState(filter?.name);
    const timer = useRef<any>(null);

    const handleChangeFilterDate = (date:any, fromName:string, toName:string) => {
        if(date.length === 2){
            const from = moment(date[0]).startOf("day").format('YYYY-MM-DD')
            const to = moment(date[1]).endOf("day").format('YYYY-MM-DD')
            setFilter({
                ...filter,
                [fromName]:from,
                [toName]:to
            })
        }else if(date.length === 0){
            setFilter({
                ...filter,
                [fromName]:undefined,
                [toName]:undefined
            })
        }   
    }

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            clearTimeout(timer.current)
            setFilter({
                ...filter,
                page: 1,
                name: e.target.value,
            })
        }
    }

    const handleChange = (e: any) => {
        clearTimeout(timer.current)
        const { name, value } = e?.target
        setFilter({
            ...filter,
            page: 1,
            [name]: value
        })
    }
    
    return (
        <Row className="mb-3 filter-custom">
            <Col xl={10}>
                <Row>
                    <Col xl={4}>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                                <img src={IconSearch} width={18} height={18} alt=""/>
                            </InputGroupAddon>
                            <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Tìm kiếm mã lô, tên sản phẩm" />
                        </InputGroup>
                    </Col>
                    <Col xl={8}>
                        <Row>
                            <Col xl={4}>
                                <InputGroup className='form-control picker-custom'>
                                    <Flatpickr 
                                        value={[new Date(moment(filter?.production_date_from,'YYYY-MM-DD').startOf('day').valueOf()), new Date(moment(filter?.production_date_to,'YYYY-MM-DD').startOf('day').valueOf())]}
                                        onChange={(date:any) => { handleChangeFilterDate(date, 'production_date_from', 'production_date_to') }} 
                                        options={{
                                            mode: "range",
                                            locale: Vietnamese,
                                            dateFormat: "d/m/Y",
                                        }}
                                        className="flatpickr-input active"
                                        placeholder="Ngày sản xuất"
                                    />
                                    <div className="icon-clear" style={{right:23}} onClick={()=>{setFilter({...filter, production_date_from: null, production_date_to:null})}}>
                                        <i className="uil-times mr-1"></i>
                                    </div>
                                    <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                            <img src={IconCalendarBlack} alt="icon" />
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                            <Col xl={4}>
                                <InputGroup className='form-control picker-custom'>
                                    <Flatpickr 
                                        value={[new Date(moment(filter?.expiration_date_from,'YYYY-MM-DD').startOf('day').valueOf()), new Date(moment(filter?.expiration_date_to,'YYYY-MM-DD').startOf('day').valueOf())]}
                                        onChange={(date:any) => { handleChangeFilterDate(date, 'expiration_date_from', 'expiration_date_to') }} 
                                        options={{
                                            mode: "range",
                                            locale: Vietnamese,
                                            dateFormat: "d/m/Y",
                                        }}
                                        className="flatpickr-input active"
                                        placeholder="Ngày hết hạn"
                                    />
                                    <div className="icon-clear" style={{right:23}} onClick={()=>{setFilter({...filter, expiration_date_from: null, expiration_date_to:null})}}>
                                        <i className="uil-times mr-1"></i>
                                    </div>
                                    <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                            <img src={IconCalendarBlack} alt="icon" />
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Trạng thái-"
                                    options={[{
                                        label: '-Trạng thái-',
                                        value: '',
                                    },...ProductStatusDate]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'status', value: value.value } })
                                    }}
                                    value={ProductStatusDate?.filter((option: any) => filter?.status == option.value)}
                                ></Select>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            {/* <Col xl={2}>
                <div className="text-right">
                    <Link to={`${configPage.pathPage}/add`}>
                        <Button color="success" className="ml-2">
                            <img className='mr-1' style={{border: 'none'}} src={IconPlus} width={20} height={20} alt=""/>  
                            Thêm
                        </Button>
                    </Link>
                </div>
            </Col> */}
        </Row>
    );
};

const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const { closeModal, action, loadData } = props

    const handleDelete = async() => {
        setLoading(true)
        const url = `${baseUrl}/product-batch/${action?.data?.id}`;
        let response: any = await APIClient.DELETE(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xóa lô thành công')
            closeModal();
            loadData()
        }
    }

    if(!checkRole(props?.user?.roles, ['userEdit'], props?.user?.role)){
        return (
            <CardBody className='p-0' style={{width:460}}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                </div>
                {loading && <Loader />}
            </CardBody>
    
        )
    }

    return (
        <CardBody className='p-0' style={{width:400}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    {
                    action?.type === 'delete' ? "Xóa lô" 
                    : "Thông báo"
                    }
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-2 pb-2">
                <Col md={12}>
                    <FormGroup row className="label-only">
                        {action?.type === 'delete' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                Bạn có chắc chắn muốn xóa lô này không?
                            </p>
                        }
                    </FormGroup>
                </Col>
            </div>
            <div className="modal-footer">
                <Button
                    onClick={()=>{
                        action?.type === 'delete' && handleDelete()
                    }}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>
            {loading && <Loader />}
        </CardBody>

    )
}

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(List)